<template>
  <div class="l_walk" :class="{ lock: this.alert }">
    <div class="container">
      <div class="hero">
        <h1>たくさん歩いて<br />限定スタンプGET♪</h1>
        <div class="subtitle">
          目標歩数を4週達成するたびに<br />限定スタンプがもらえます。<br />楽しく歩いて食事もおいしく♪
        </div>
        <div class="image">
          <img :src="require('@/assets/img/walk/runnninggirl.png')" />
        </div>
        <div class="button" @click="openWalk">ウォークスタンプを始める</div>
        <div class="ver_caution">
          ※ウォークスタンプ機能は、アプリバージョン4.0.0以上対応です。<br />
          <span class="android"
            >※Android端末のお客様はGoogle
            Fitアプリをインストールの上、GoogleFitにもアカウントを連携して歩数がカウントできるよう設定してください。（香の川製麺アプリに連携したGoogleアカウントと同じGoogleアカウントを設定してください。）</span
          >
        </div>
        <div class="info_android"></div>
        <div class="button" @click="openFAQ">ウォークスタンプQ&A</div>
        <div class="caution">
          7日以上ウォークページを開かないと<br />
          歩数データの一部が反映できなくなります。<br />
          毎週チェックして下さい♪<br />
          <span class="small"
            >※遡ってデータ反映ができるのは最大7日分となります。</span
          >
        </div>
      </div>
      <div class="content">
        <h3>4週分歩数目標を達成すると1スタンプ獲得！</h3>
        <hr />
        <p>
          1週間の歩数目標は30,000歩。4週分週間の歩数目標を達成すると1スタンプがもらえます。（連続達成でなくても大丈夫です）<br />
          1週間は毎週月曜から日曜をひとくぎりとします。<br />
          ※キャンペーン中は歩数目標、獲得スタンプ数が変更になる場合がございます。
        </p>

        <img :src="require('@/assets/img/walk/tassei_new.png')" />
        <br />
        <br />

        <h3>よくあるご質問</h3>
        <hr />
        <div>
          <h4>Q：歩数がカウントされません。</h4>

          <p>
            A:最新の歩数は、マイページ内にある「ウォーク機能」ボタンをタップし、ウォーク画面トップを表示するか、ウォーク画面内の「更新ボタン」を押すことで最新の歩数が反映されます。以上の動作でも歩数が更新されない場合、お使いの端末の歩数計データとの連携設定をご確認ください。<br />
            ・省電力モード等の設定によってはアプリのバックグラウンド起動が終了される場合があります。省電力モード対象のアプリ設定から香の川製麺アプリを除外してください。<br />
            ・Android8.0以降をお使いの場合、設定＞バッテリーから香の川製麺アプリを選択し、バックグラウンドアクティビティをオンにしてください。<br />
            ・端末の日付は必ず<b>現在の日付</b>を<b>西暦</b>で設定してください。設定されない場合、動作の保証ができない可能性があります。<br /><br />
            上記でも改善されない場合、下記をご確認ください。<br />
          </p>
          <h4>■ウォーク機能を使うための設定確認</h4>
          <p>連携後の画面になっていること</p>
          <img :src="require('@/assets/img/walk/renkeimae_ato.png')" />
          <p>
            ○iOSのお客様へ<br />
            ・一部端末では正常に動作しない場合があります。<br />
            ・iPad及びiPod touchでは動作を保証しておりません。<br />
            あらかじめご了承ください。<br />
            <br />
            ○Androidのお客様へ<br />
            ・Android端末のお客様はGoogle Fitアプリをインストールの上、Google
            Fitにもアカウント連携をして歩数がカウントできるように設定してください。<br />
            （香の川製麺アプリに連携したGoogleアカウントと同じGoogleアカウントを設定してください。）<br />
            <br />
          </p>
        </div>

        <br />
        <img :src="require('@/assets/img/walk/walk-q11-2-1.png')" />
        <br />
        <div>
          <p>※一部端末では正常に動作しない場合があります。</p>
          <div class="l_button__external">
            <UIButton :label="'もっと見る'" @click="openFAQ" />
          </div>
          <div class="l_button__external">
            <UIButton :label="'ウォークスタンプをためる'" @click="openWalk" />
          </div>
        </div>
        <br />
        <br />
      </div>
    </div>

    <VersionCheck :show="this.alert" :on-close="closeAlert" />
  </div>
</template>

<script>
import UIButton from '@/components/UIButton'
import VersionCheck from './FAQWalkVersionCheck'
import { mapActions } from 'vuex'
import { FactoryTrack } from '@/constant/firebase'

export default {
  name: 'FAQWalk',
  components: {
    UIButton,
    VersionCheck
  },
  data: function () {
    return {
      alert: 0
    }
  },
  created() {
    document.title = 'ウォークスタンプについて'
  },
  methods: {
    ...mapActions('Native', ['actionOpenWalk', 'actionRequestExternalLink']),
    ...mapActions('Analytics', ['trackEvent']),
    openWalk: async function () {
      this.trackEvent(FactoryTrack.createWalk())
      this.alert = await this.actionOpenWalk()
    },
    closeAlert: function () {
      this.trackEvent(FactoryTrack.createVersionCheckClose())
      this.alert = 0
    },
    openFAQ: function () {
      this.trackEvent(FactoryTrack.createFAQWalkQA())
      this.$router.push({ path: '/faq/walk/faq' })
    }
  }
}
</script>

<style lang="scss" scoped>
.l_button__external {
  width: 250px;
  margin: 20px auto 0;
}

.l_walk {
  color: #333333;
  width: 100%;
  height: 100vh;
  background-color: #ffffff;
  text-align: center;
  overflow: scroll;
  &.lock {
    overflow: hidden;
  }

  .hero {
    background: var(--background-color);
    text-align: center;
    padding: 20px 0;
    h1 {
      color: #ed2a32;
      font-size: 7vw;
      font-weight: 900;
    }
    .subtitle {
      margin: 10px 0;
      font-size: 4vw;
    }

    .image {
      margin: 20px 0;
      text-align: center;
      img {
        max-width: 100%;
      }
    }
    .button {
      color: #ffffff;
      font-weight: bold;
      /* background: linear-gradient(to right, #fea666, #f83746); */

      background-image: url('~@/assets/img/walk/btn-walk.png');
      background-size: cover;
      background-position: center;
      width: 80%;
      display: inline-block;
      margin: 8px 0;
      padding: 16px 0;
      border-radius: 4px;
    }

    .ver_caution {
      font-size: 3vw;
      color: #666666;
      margin: 0 20px 10px;
      text-align: justify;
    }
    .caution {
      text-align: center;
      margin: 0 10px;
      font-size: 4vw;
      color: #3e3e3e;
      .small {
        font-size: 3vw;
      }
    }
  }
  .content {
    h3,
    h4 {
      color: #602209;
      font-family: 'HiraKakuPro-W6', sans-serif;
    }
    h4 {
      margin: 10px 0px;
    }

    background-color: #ffffff;
    text-align: left;
    padding: 20px;

    hr {
      margin-top: 10px;
      margin-bottom: 10px;
      border: none;
      border-bottom: 1px solid #efb90f;
    }
    img {
      margin-top: 10px;
      margin-bottom: 10px;
      max-width: 100%;
      text-align: center;
    }
    p {
      word-break: break-all;
      text-align: justify;
    }
  }
}
</style>
